<div class="auth-nav-bar">
  <mat-toolbar>
    <div class="nav-bar-left">
      <span class="logo">
        <a routerLink="/guest/landing">
          <img
            src="assets/Images/Logo/logo.png"
            alt="MariHub Logo"
          />
        </a>
      </span>
      <div
        [className]="
          user.isLoggedIn &&
          user.accountTypeCode === accountType.BUYER_PORTAL &&
          userDetailsService.checkPermissions(
            permission.ACCESS_COMPANY_ACCOUNT_CONFIGURATION
          )
            ? 'nav-bar-btns hide-nav-btns-client'
            : 'nav-bar-btns hide-nav-btns'
        "
      >
        <button
          mat-button
          routerLink="/dashboard"
          routerLinkActive="mat-active"
          *ngIf="
            user.isLoggedIn &&
            user.isSuperAdmin === 'false' &&
            user.roleCode !== memberType.Logistics_Team
          "
        >
          <mat-icon class="material-icons-outlined">widgets</mat-icon>
          My Dashboard
        </button>
        <button
          mat-button
          routerLink="/logistics/orders"
          routerLinkActive="mat-active"
          *ngIf="
            user.isLoggedIn &&
            user.isSuperAdmin === 'false' &&
            user.roleCode === memberType.Logistics_Team
          "
        >
          <mat-icon class="material-icons-outlined">content_paste</mat-icon>
          Manage Order
        </button>
        <!--    <button mat-button [matMenuTriggerFor]="shopMenu" routerLinkActive="mat-active"-->
        <!--            *ngIf="user.isLoggedIn &&  user.isSuperAdmin === 'false' && user.roleCode !== memberType.Logistics_Team"-->
        <!--            [class.mat-active]="isDirectoryPath('shop')"-->
        <!--    >-->
        <!--        <mat-icon class="material-icons-outlined">storefront</mat-icon>-->
        <!--        Shop-->
        <!--    </button>-->

        <!--    <button mat-button routerLinkActive="mat-active" (click)="selectPortForShop(category.data[0].id)"-->
        <!--            *ngIf="user.isLoggedIn &&  user.isSuperAdmin === 'false' && user.roleCode !== memberType.Logistics_Team"-->
        <!--            [class.mat-active]="isDirectoryPath('shop')">-->
        <!--        <mat-icon class="material-icons-outlined">storefront</mat-icon>-->
        <!--        Shop-->
        <!--    </button>-->
        <button
          mat-button
          routerLinkActive="mat-active"
          (click)="onNavigateToShop()"
          *ngIf="
            user.isLoggedIn &&
            user.isSuperAdmin === 'false' &&
            user.roleCode !== memberType.Logistics_Team &&
            user.roleCode !== memberType.Procurement_Team
          "
          [class.mat-active]="isDirectoryPath('shopping')"
        >
          <mat-icon class="material-icons-outlined">storefront</mat-icon>
          Shop
        </button>
        <button
          mat-button
          routerLink="/order"
          routerLinkActive="mat-active"
          *ngIf="
            user.isLoggedIn &&
            user.accountTypeCode === accountType.BUYER_PORTAL &&
            user.isSuperAdmin === 'false'
          "
        >
          <mat-icon class="material-icons-outlined">content_paste</mat-icon>
          My Orders
        </button>
        <button
          mat-button
          routerLink="/client"
          routerLinkActive="mat-active"
          *ngIf="
            user.isLoggedIn &&
            user.accountTypeCode === accountType.MARIHUB_PORTAL &&
            user.isSuperAdmin === 'false' &&
            user.roleCode === memberType.Sales_Team
          "
        >
          <mat-icon class="material-icons-outlined">directions_boat</mat-icon>
          Manage Clients
        </button>
        <!--    <button mat-button routerLinkActive="mat-active" routerLink="/manage-orders/orders"-->
        <!--            *ngIf="user.isLoggedIn && user.accountTypeCode === accountType.MARIHUB_PORTAL &&  user.isSuperAdmin === 'false' && user.roleCode === memberType.Sales_Team">-->
        <!--        <mat-icon class="material-icons-outlined">content_paste</mat-icon>-->
        <!--        Manage Orders-->
        <!--    </button>  -->
        <button
          mat-button
          routerLinkActive="mat-active"
          routerLink="/order"
          *ngIf="
            user.isLoggedIn &&
            user.accountTypeCode === accountType.MARIHUB_PORTAL &&
            user.isSuperAdmin === 'false' &&
            user.roleCode === memberType.Sales_Team
          "
        >
          <mat-icon class="material-icons-outlined">content_paste</mat-icon>
          Manage Orders
        </button>
        <button
          mat-button
          [class.mat-active]="isDirectoryPath('product-catalogue')"
          routerLink="/product-catalogue/catalogue/{{ category.data[0]?.id }}"
          *ngIf="
            user.isLoggedIn &&
            user.accountTypeCode === accountType.MARIHUB_PORTAL &&
            user.isSuperAdmin === 'false' &&
            category.data &&
            user.roleCode === memberType.Sales_Team
          "
        >
          <mat-icon class="material-icons-outlined">layers</mat-icon>
          Product Catalogue
        </button>
        <button
          mat-button
          [class.mat-active]="isDirectoryPath('product-catalog')"
          routerLink="/product-catalog/catalog/{{ category.data[0]?.id }}"
          *ngIf="
            user.isLoggedIn &&
            user.accountTypeCode === accountType.MARIHUB_PORTAL &&
            user.isSuperAdmin === 'false' &&
            category.data &&
            user.roleCode === memberType.Procurement_Team
          "
        >
          <mat-icon class="material-icons-outlined">layers</mat-icon>
          Product Catalogue
        </button>
        <button
          mat-button
          [class.mat-active]="isDirectoryPath('system-category')"
          routerLink="/system-category/category/{{ category.data[0]?.id }}"
          *ngIf="
            user.isLoggedIn &&
            user.accountTypeCode === accountType.MARIHUB_PORTAL &&
            user.isSuperAdmin === 'false' &&
            category.data &&
            user.roleCode === memberType.Procurement_Team
          "
        >
          <mat-icon class="material-icons-outlined">account_tree</mat-icon>
          System Categories
        </button>
        <button
          mat-button
          routerLinkActive="mat-active"
          routerLink="/ports"
          *ngIf="
            user.isLoggedIn &&
            user.accountTypeCode === accountType.MARIHUB_PORTAL &&
            user.isSuperAdmin === 'false' &&
            user.roleCode === memberType.Procurement_Team
          "
        >
          <mat-icon class="material-icons-outlined">map</mat-icon>
          Ports
        </button>
        <button
          mat-button
          routerLinkActive="mat-active"
          routerLink="/vendors"
          *ngIf="
            user.isLoggedIn &&
            user.accountTypeCode === accountType.MARIHUB_PORTAL &&
            user.isSuperAdmin === 'false' &&
            user.roleCode === memberType.Procurement_Team
          "
        >
          <mat-icon class="material-icons-outlined">museum</mat-icon>
          Vendors
        </button>
        <button
          mat-button
          routerLinkActive="mat-active"
          routerLink="/brands"
          *ngIf="
            user.isLoggedIn &&
            user.accountTypeCode === accountType.MARIHUB_PORTAL &&
            user.isSuperAdmin === 'false' &&
            user.roleCode === memberType.Procurement_Team
          "
        >
          <mat-icon class="material-icons-outlined">book</mat-icon>
          Brands
        </button>

        <button
          mat-button
          routerLink="/marihub-portal/admin-panel/manage-members/"
          routerLinkActive="mat-active"
          *ngIf="
            user.isLoggedIn &&
            user.accountTypeCode === accountType.MARIHUB_PORTAL &&
            user.isSuperAdmin === 'true'
          "
        >
          <mat-icon class="material-icons-outlined">people_alt</mat-icon>
          Manage Members
        </button>
        <!--<button mat-button routerLink="/analytics-and-reports" routerLinkActive="mat-active"
                *ngIf="user.isLoggedIn && user.accountTypeCode === accountType.BUYER_PORTAL &&  user.isSuperAdmin === 'false'">
            <mat-icon class="material-icons-outlined">assessment</mat-icon>
            Analytics & Reports
        </button>-->
        <!--    <button mat-icon-button class="mat-active " aria-label="Example icon-button with heart icon"-->
        <!--            *ngIf="user.isLoggedIn">-->
        <!--        <mat-icon class="h-100">notifications_none</mat-icon>-->
        <!--    </button>-->
        <!--     <app-system-notification></app-system-notification>-->
      </div>
    </div>
    <div class="header-user-notification">
      <button
        [className]="
          user.isLoggedIn &&
          user.accountTypeCode === accountType.BUYER_PORTAL &&
          userDetailsService.checkPermissions(
            permission.ACCESS_COMPANY_ACCOUNT_CONFIGURATION
          )
            ? 'header-notification-btn hide-nav-btns-client'
            : 'header-notification-btn hide-nav-btns'
        "
        [ngClass]="{
          disabled: systemNotificationService.signalData.count === 0
        }"
        mat-button
        [matMenuTriggerFor]="notificationsMenu"
      >
        <mat-icon class="nav-menu-btn__icon">notifications_none</mat-icon>

        <!-- <svg
          width="14"
          height="17"
          viewBox="0 0 14 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.075 12.7379L12 11.6629V7.49624C12 4.9379 10.6333 2.79624 8.25001 2.22957V1.6629C8.25001 0.971236 7.69168 0.412903 7.00001 0.412903C6.30835 0.412903 5.75001 0.971236 5.75001 1.6629V2.22957C3.35835 2.79624 2.00001 4.92957 2.00001 7.49624V11.6629L0.925012 12.7379C0.400012 13.2629 0.766679 14.1629 1.50835 14.1629H12.4833C13.2333 14.1629 13.6 13.2629 13.075 12.7379ZM10.3333 12.4962H3.66668V7.49624C3.66668 5.42957 4.92501 3.74624 7.00001 3.74624C9.07501 3.74624 10.3333 5.42957 10.3333 7.49624V12.4962ZM7.00001 16.6629C7.91668 16.6629 8.66668 15.9129 8.66668 14.9962H5.33335C5.33335 15.9129 6.07501 16.6629 7.00001 16.6629Z"
            fill="#00B2FF"
          />
        </svg> -->
        <span
          class="header-notification-btn--badge animate__animated animate__fadeIn"
          *ngIf="systemNotificationService.signalData.count > 0"
          >{{ systemNotificationService.signalData.count }}</span
        >
      </button>
      <button
        [className]="
          user.isLoggedIn &&
          user.accountTypeCode === accountType.BUYER_PORTAL &&
          userDetailsService.checkPermissions(
            permission.ACCESS_COMPANY_ACCOUNT_CONFIGURATION
          )
            ? 'btn nav-menu-btn show-nav-menu-client'
            : 'btn nav-menu-btn show-nav-menu'
        "
        [ngClass]="{
          disabled: systemNotificationService.signalData.count === 0
        }"
        [matMenuTriggerFor]="notificationsMenu"
      >
        <mat-icon class="nav-menu-btn__icon">notifications_none</mat-icon>
      </button>
      <span class="spacer">|</span>

      <button
        [className]="
          user.isLoggedIn &&
          user.accountTypeCode === accountType.BUYER_PORTAL &&
          userDetailsService.checkPermissions(
            permission.ACCESS_COMPANY_ACCOUNT_CONFIGURATION
          )
            ? 'mat-button hide-nav-btns-client'
            : 'mat-button hide-nav-btns'
        "
        mat-button
        [matMenuTriggerFor]="userMenu"
        *ngIf="user.isLoggedIn"
      >
        <!--        <img [src]="user.profileImg" [alt]="user.name">-->
        <img
          [src]="imgSrc + user.profileImg"
          class="img-profile"
          [alt]="user.name"
          *ngIf="user.profileImg"
        />
        <mat-icon
          *ngIf="!user.profileImg"
          class="material-icons-outlined text-primary img-profile"
        >
          account_circle
        </mat-icon>
        <span>{{ user.name }}</span>
        <mat-icon class="icon-arrow-profile">keyboard_arrow_down</mat-icon>
      </button>
      <button
        [className]="
          user.isLoggedIn &&
          user.accountTypeCode === accountType.BUYER_PORTAL &&
          userDetailsService.checkPermissions(
            permission.ACCESS_COMPANY_ACCOUNT_CONFIGURATION
          )
            ? 'btn nav-menu-btn show-nav-menu-client'
            : 'btn nav-menu-btn show-nav-menu'
        "
        (click)="onToggleMenu()"
      >
        <mat-icon class="nav-menu-btn__icon">menu</mat-icon>
      </button>

      <button
        mat-button
        routerLink="/auth/sign-in"
        routerLinkActive="mat-active"
        *ngIf="!user.isLoggedIn"
      >
        Login
      </button>
    </div>
  </mat-toolbar>
</div>

<mat-menu
  #shopMenu="matMenu"
  class="customize"
>
  <!--    routerLink="/shop/{{cat.id}}"-->
  <button
    mat-menu-item
    routerLinkActive="mat-active"
    *ngFor="let cat of category.data"
    (click)="selectPortForShop(cat.id)"
  >
    {{ cat.name }}
  </button>
</mat-menu>

<mat-menu
  #notificationsMenu="matMenu"
  class="header-notifications-menu notifications"
>
  <div class="header-notifications-menu--wrapper">
    <div class="header-notifications-menu--ttl">
      <h2>Notifications</h2>

      <span class="material-icons-outlined"> notifications </span>
    </div>
    <div class="header-notifications-menu--list-wrapper">
      <ul class="header-notifications-menu--list">
        <li
          class="header-notifications-menu--item"
          *ngFor="let notify of systemNotificationService.signalData.data"
          [ngClass]="{ active: !notify.isRead }"
        >
          <button
            class="header-notifications-menu--item-btn"
            (click)="!notify.isRead ? onReadNotify(notify) : null"
            [routerLink]="[
              '/order',
              notify.notifiedId,
              'summary',
              notify.notifiedId
            ]"
          >
            <div class="header-notifications-menu--item-ttl">
              <h2>{{ notify.text }}</h2>
              <p>{{ notify.description }}</p>
            </div>
            <div class="header-notifications-menu&#45;&#45;item-time">
              <span>{{ Moment(notify.createdOn).fromNow() }}</span>
            </div>
          </button>
        </li>
      </ul>
    </div>
    <!--        <button class="header-notifications-menu&#45;&#45;btn">-->
    <!--            View All-->
    <!--            <span class="material-icons-outlined">-->
    <!--                east-->
    <!--            </span>-->
    <!--        </button>-->
  </div>
</mat-menu>

<mat-menu
  #userMenu="matMenu"
  class="customize-user"
>
  <div class="profile-sub-menu py-15">
    <img
      [src]="imgSrc + user.profileImg"
      [alt]="user.name"
      *ngIf="user.profileImg"
    />
    <mat-icon
      *ngIf="!user.profileImg"
      class="m-0 material-icons-outlined text-primary"
    >
      account_circle
    </mat-icon>
    <div class="grid-3gap">
      <span class="name">{{ user.name }}</span>
      <span>{{ user.emailAddress }}</span>
    </div>
  </div>
  <div class="profile-sub-menu pb-15">
    <button
      mat-menu-item
      routerLink="/personal/profile"
      class="flex-row d-flex justify-content-start btn-profile-menu align-items-center"
    >
      <mat-icon class="material-icons-outlined size-23 icon"> person </mat-icon>
      My Profile
    </button>
  </div>
  <!--    <button mat-menu-item routerLink="/personal/complaint">-->
  <!--        <mat-icon class="material-icons-outlined icon">-->
  <!--            flag-->
  <!--        </mat-icon>-->
  <!--        Make Complaint-->
  <!--    </button>-->
  <div class="profile-sub-menu-last">
    <button
      mat-menu-item
      (click)="logOut()"
      class="flex-row d-flex btn-profile-menu justify-content-start align-items-center"
    >
      <mat-icon class="material-icons-outlined size-23 icon"> logout </mat-icon>
      LogOut
    </button>
  </div>
</mat-menu>

<div
  *ngIf="toggleFlag"
  class="navigation-overlay"
>
  <div [className]="toggleFlag ? 'navigation' : 'navigation-hide'">
    <div class="navigation__top-container">
      <div class="navigation__title">Menu</div>
      <mat-icon
        (click)="onToggleMenu()"
        class="material-icons-outlined"
        >close</mat-icon
      >
    </div>
    <div class="navigation__btn">
      <button
        mat-button
        routerLink="/dashboard"
        routerLinkActive="mat-active"
        (click)="onToggleMenu()"
        *ngIf="
          user.isLoggedIn &&
          user.isSuperAdmin === 'false' &&
          user.roleCode !== memberType.Logistics_Team
        "
      >
        <mat-icon class="material-icons-outlined">widgets</mat-icon>
        My Dashboard
      </button>
      <button
        mat-button
        routerLink="/logistics/orders"
        routerLinkActive="mat-active"
        (click)="onToggleMenu()"
        *ngIf="
          user.isLoggedIn &&
          user.isSuperAdmin === 'false' &&
          user.roleCode === memberType.Logistics_Team
        "
      >
        <mat-icon class="material-icons-outlined">content_paste</mat-icon>
        Manage Order
      </button>
      <button
        mat-button
        routerLinkActive="mat-active"
        (click)="onToggleMenuShop()"
        *ngIf="
          user.isLoggedIn &&
          user.isSuperAdmin === 'false' &&
          user.roleCode !== memberType.Logistics_Team &&
          user.roleCode !== memberType.Procurement_Team
        "
        [class.mat-active]="isDirectoryPath('shopping')"
      >
        <mat-icon class="material-icons-outlined">storefront</mat-icon>
        Shop
      </button>
      <button
        mat-button
        routerLink="/order"
        routerLinkActive="mat-active"
        (click)="onToggleMenu()"
        *ngIf="
          user.isLoggedIn &&
          user.accountTypeCode === accountType.BUYER_PORTAL &&
          user.isSuperAdmin === 'false'
        "
      >
        <mat-icon class="material-icons-outlined">content_paste</mat-icon>
        My Orders
      </button>
      <button
        mat-button
        routerLink="/client"
        routerLinkActive="mat-active"
        (click)="onToggleMenu()"
        *ngIf="
          user.isLoggedIn &&
          user.accountTypeCode === accountType.MARIHUB_PORTAL &&
          user.isSuperAdmin === 'false' &&
          user.roleCode === memberType.Sales_Team
        "
      >
        <mat-icon class="material-icons-outlined">directions_boat</mat-icon>
        Manage Clients
      </button>
      <button
        mat-button
        routerLinkActive="mat-active"
        routerLink="/order"
        (click)="onToggleMenu()"
        *ngIf="
          user.isLoggedIn &&
          user.accountTypeCode === accountType.MARIHUB_PORTAL &&
          user.isSuperAdmin === 'false' &&
          user.roleCode === memberType.Sales_Team
        "
      >
        <mat-icon class="material-icons-outlined">content_paste</mat-icon>
        Manage Orders
      </button>
      <button
        mat-button
        [class.mat-active]="isDirectoryPath('product-catalogue')"
        routerLink="/product-catalogue/catalogue/{{ category.data[0]?.id }}"
        (click)="onToggleMenu()"
        *ngIf="
          user.isLoggedIn &&
          user.accountTypeCode === accountType.MARIHUB_PORTAL &&
          user.isSuperAdmin === 'false' &&
          category.data &&
          user.roleCode === memberType.Sales_Team
        "
      >
        <mat-icon class="material-icons-outlined">layers</mat-icon>
        Product Catalogue
      </button>
      <button
        mat-button
        [class.mat-active]="isDirectoryPath('product-catalog')"
        routerLink="/product-catalog/catalog/{{ category.data[0]?.id }}"
        (click)="onToggleMenu()"
        *ngIf="
          user.isLoggedIn &&
          user.accountTypeCode === accountType.MARIHUB_PORTAL &&
          user.isSuperAdmin === 'false' &&
          category.data &&
          user.roleCode === memberType.Procurement_Team
        "
      >
        <mat-icon class="material-icons-outlined">layers</mat-icon>
        Product Catalogue
      </button>
      <button
        mat-button
        [class.mat-active]="isDirectoryPath('system-category')"
        routerLink="/system-category/category/{{ category.data[0]?.id }}"
        (click)="onToggleMenu()"
        *ngIf="
          user.isLoggedIn &&
          user.accountTypeCode === accountType.MARIHUB_PORTAL &&
          user.isSuperAdmin === 'false' &&
          category.data &&
          user.roleCode === memberType.Procurement_Team
        "
      >
        <mat-icon class="material-icons-outlined">account_tree</mat-icon>
        System Categories
      </button>
      <button
        mat-button
        routerLinkActive="mat-active"
        routerLink="/ports"
        (click)="onToggleMenu()"
        *ngIf="
          user.isLoggedIn &&
          user.accountTypeCode === accountType.MARIHUB_PORTAL &&
          user.isSuperAdmin === 'false' &&
          user.roleCode === memberType.Procurement_Team
        "
      >
        <mat-icon class="material-icons-outlined">map</mat-icon>
        Ports
      </button>
      <button
        mat-button
        routerLinkActive="mat-active"
        routerLink="/vendors"
        (click)="onToggleMenu()"
        *ngIf="
          user.isLoggedIn &&
          user.accountTypeCode === accountType.MARIHUB_PORTAL &&
          user.isSuperAdmin === 'false' &&
          user.roleCode === memberType.Procurement_Team
        "
      >
        <mat-icon class="material-icons-outlined">museum</mat-icon>
        Vendors
      </button>
      <button
        mat-button
        routerLinkActive="mat-active"
        routerLink="/brands"
        (click)="onToggleMenu()"
        *ngIf="
          user.isLoggedIn &&
          user.accountTypeCode === accountType.MARIHUB_PORTAL &&
          user.isSuperAdmin === 'false' &&
          user.roleCode === memberType.Procurement_Team
        "
      >
        <mat-icon class="material-icons-outlined">book</mat-icon>
        Brands
      </button>
      <button
        mat-button
        routerLink="/marihub-portal/admin-panel/manage-members/"
        routerLinkActive="mat-active"
        (click)="onToggleMenu()"
        *ngIf="
          user.isLoggedIn &&
          user.accountTypeCode === accountType.MARIHUB_PORTAL &&
          user.isSuperAdmin === 'true'
        "
      >
        <mat-icon class="material-icons-outlined">people_alt</mat-icon>
        Manage Members
      </button>
    </div>
    <div class="navigation__border-top"></div>

    <div class="navigation__title">Settings</div>
    <div class="navigation__btn">
      <button
        mat-button
        routerLink="/personal/profile"
        (click)="onToggleMenu()"
        class="btn-settings"
      >
        <mat-icon class="material-icons-outlined"> person </mat-icon>
        My Profile
      </button>
      <button
        mat-button
        (click)="logOut()"
        class="btn-settings"
      >
        <mat-icon class="material-icons-outlined"> logout </mat-icon>
        LogOut
      </button>
    </div>
  </div>
</div>
